import { createContext, useState, useEffect, useContext } from "react";
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { queryClient } from "../adapters/api";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const { instance, accounts, inProgress } = useMsal();
  const [auth, setAuth] = useState(() => {
    const storedState = localStorage.getItem("authState");
    const userData = storedState ? JSON.parse(storedState) : null;

    return userData
      ? {
          staff_id: userData.staff_id,
          permissions: userData.permissions,
          token: userData.token,
        }
      : {
          staff_id: null,
          permissions: [],
          token: null,
        };
  });

  // useEffect(() => {
  //   const initializeAuth = async () => {
  //     if (accounts.length > 0) {
  //       await loginWithAzure(accounts[0]);
  //     } else {
  //       setAuth((prevAuth) => ({
  //         ...prevAuth,
  //         user: null,
  //         isAuthenticated: false,
  //         token: null,
  //         permissions: [],
  //       }));
  //     }
  //   };

  //   if (inProgress === "none") {
  //     initializeAuth();
  //   }
  // }, [accounts, inProgress]);

  useEffect(() => {
    if (auth.staff_id) {
      localStorage.setItem("authState", JSON.stringify(auth));
    }
  }, [auth]);

  const navigate = useNavigate();
  const loginWithAzure = async (account) => {
    try {
      const response = await instance.acquireTokenSilent({
        scopes: ["user.read", "profile", "email"],
        account: account,
      });

      const result = await axios.post(
        "https://approvalbackend.vercel.app/users/azure_login",
        {
          azure_token: response.idToken,
          email: response.account.username,
        },
        {
          withCredentials: true, // This is important for handling cookies
        }
      );

      const { token } = result.data;

      // Decode the token to get user information
      const decodedToken = jwtDecode(token);
      const permissions = decodedToken.permissions;
      const staff_id = decodedToken.staff_id;
      setAuth({ staff_id, permissions, token });
      // Redirect based on user roles/permissions
      queryClient.invalidateQueries("userdata");

      setAuth({
        staff_id: staff_id,
        isAuthenticated: true,
        token: token,
        permissions: permissions,
      });

      navigate("/dashboard");
    } catch (error) {
      console.error("Error logging in", error);
    }
  };

  const login = async () => {
    try {
      const response = await instance.loginPopup({
        scopes: ["user.read"],
        prompt: "select_account",
      });
      if (response.account) {
        await loginWithAzure(response.account);
      }
    } catch (error) {
      console.error("Login failed", error);
    }
  };

  const logout = async () => {
    setAuth({
      staff_id: null,
      permissions: [],
      token: null,
    });
    localStorage.removeItem("authState");
  };

  return (
    <AuthContext.Provider value={{ auth, setAuth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
